export default {
  searchIcon: 'https://cdn.recyclecoach.com/webapp-resources/img/search.png',
  closeIcon: 'https://cdn.recyclecoach.com/webapp-resources/img/close_dark.png',
  closeIconWhite: 'https://cdn.recyclecoach.com/webapp-resources/img/icon_close_white.png',
  recycleCoachLogo: `${process.env.PUBLIC_URL}/images/footer/rc.svg`,
  selectArrowDown: `${process.env.PUBLIC_URL}/images/header/down-arrow-svgrepo-com.svg`,
  iosLogo: `${process.env.PUBLIC_URL}/images/footer/apple_150x43.png`,
  androidLogo: `${process.env.PUBLIC_URL}/images/footer/google_150x43.png`,

  calendar: {
    iconicShape: 'https://cdn.recyclecoach.com/webapp-resources/img/calendar/icon/',
    changeZone: `${process.env.PUBLIC_URL}/images/calendar/change_zone.svg`,
    leftArrow: `${process.env.PUBLIC_URL}/images/calendar/left-arrow.svg`,
    rightArrow: `${process.env.PUBLIC_URL}/images/calendar/right-arrow.svg`,
    msCalendar: `${process.env.PUBLIC_URL}/images/calendar/ms-calendar.png`,
    copyLink: `${process.env.PUBLIC_URL}/images/calendar/copy-link.svg`,
    'wheel-bin': `${process.env.PUBLIC_URL}/images/calendar/wheel-bin.png`,
    twigs: `${process.env.PUBLIC_URL}/images/calendar/twigs.png`,
    tree: `${process.env.PUBLIC_URL}/images/calendar/tree.png`,
    television: `${process.env.PUBLIC_URL}/images/calendar/television.png`,
    stove: `${process.env.PUBLIC_URL}/images/calendar/stove.png`,
    'simple-bin': `${process.env.PUBLIC_URL}/images/calendar/simple-bin.png`,
    shoppingbag: `${process.env.PUBLIC_URL}/images/calendar/shoppingbag.png`,
    'shoppingbag-recycle': `${process.env.PUBLIC_URL}/images/calendar/shoppingbag-recycle.png`,
    recycle: `${process.env.PUBLIC_URL}/images/calendar/recycle.png`,
    'recycle-bin': `${process.env.PUBLIC_URL}/images/calendar/recycle-bin.png`,
    recircle: `${process.env.PUBLIC_URL}/images/calendar/recircle.png`,
    paperbag: `${process.env.PUBLIC_URL}/images/calendar/paperbag.png`,
    'organic-bin': `${process.env.PUBLIC_URL}/images/calendar/organic-bin.png`,
    megaphone: `${process.env.PUBLIC_URL}/images/calendar/megaphone.png`,
    leaf: `${process.env.PUBLIC_URL}/images/calendar/leaf.png`,
    Icon__Street_Sweeping: `${process.env.PUBLIC_URL}/images/calendar/Icon__Street_Sweeping.png`,
    Icon__Shredding_Event: `${process.env.PUBLIC_URL}/images/calendar/Icon__Shredding_Event.png`,
    hazard: `${process.env.PUBLIC_URL}/images/calendar/hazard.png`,
    grass: `${process.env.PUBLIC_URL}/images/calendar/grass.png`,
    garbagebin: `${process.env.PUBLIC_URL}/images/calendar/garbagebin.png`,
    garbagebag: `${process.env.PUBLIC_URL}/images/calendar/garbagebag.png`,
    fridge: `${process.env.PUBLIC_URL}/images/calendar/fridge.png`,
    flag: `${process.env.PUBLIC_URL}/images/calendar/flag.png`,
    exclamation: `${process.env.PUBLIC_URL}/images/calendar/exclamation.png`,
    evergreen: `${process.env.PUBLIC_URL}/images/calendar/evergreen.png`,
    couch: `${process.env.PUBLIC_URL}/images/calendar/couch.png`,
    computer: `${process.env.PUBLIC_URL}/images/calendar/computer.png`,
    coach: `${process.env.PUBLIC_URL}/images/calendar/coach.png`,
    chair: `${process.env.PUBLIC_URL}/images/calendar/chair.png`,
    biohazard: `${process.env.PUBLIC_URL}/images/calendar/biohazard.png`,
    bell: `${process.env.PUBLIC_URL}/images/calendar/bell.png`,
    battery: `${process.env.PUBLIC_URL}/images/calendar/battery.png`,
    apple: `${process.env.PUBLIC_URL}/images/calendar/apple.png`,
    alarm: `${process.env.PUBLIC_URL}/images/calendar/alarm.png`,
  },

  icons: {
    hrs: 'https://cdn.recyclecoach.com/webapp-resources/img/hrs.png',
    link: 'https://cdn.recyclecoach.com/webapp-resources/img/link.png',
    phone: 'https://cdn.recyclecoach.com/webapp-resources/img/phone.png',
    email: 'https://cdn.recyclecoach.com/webapp-resources/img/mail-icon.png',
    dropDown: 'https://cdn.recyclecoach.com/webapp-resources/img/icon_dropdown.png',
    collArrow: 'https://cdn.recyclecoach.com/webapp-resources/img/icon-column-arrow@2x.png',
    bullet: 'https://cdn.recyclecoach.com/webapp-resources/img/shell/bg-info-bullet@2x.png',
    marker: `${process.env.PUBLIC_URL}/images/depotEvent/marker.svg`,
    checkmark: `${process.env.PUBLIC_URL}/images/resources/checkmark.svg`,
    blackArrowDown: `${process.env.PUBLIC_URL}/images/arrow_down_black.svg`,
    checkbox: `${process.env.PUBLIC_URL}/images/download-pdf/checkbox.svg`,
  },
  resources: {
    mobile: `${process.env.PUBLIC_URL}/images/resources/mobile2.png`,
    rc_kids_image: `${process.env.PUBLIC_URL}/images/resources/Celebrate.png`,
    rc_kids_image_empty: `${process.env.PUBLIC_URL}/images/resources/Celebrate_empty.png`,
  },
  materialDetails: {
    share: `${process.env.PUBLIC_URL}/images/material-details/share.svg`,
    rp: `${process.env.PUBLIC_URL}/images/material-details/rp.svg`,
  },
  education: {
    kids: `${process.env.PUBLIC_URL}/images/education/kids.png`,
    recycle_right: `${process.env.PUBLIC_URL}/images/education/recycle-right.svg`,
  },
  recycleRight: {
    close: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/close.svg`,
    arrow: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/arrow.svg`,
    wrong: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/wrong.svg`,
    correct: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/correct.svg`,
    decline: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/decline.svg`,
    great_job: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/great-job.svg`,
    happy_emoji: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/happy-emoji.svg`,
    on_boarding_arrow: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/on-boarding-arrow.svg`,
    on_boarding: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/on-boarding.svg`,
    recycable: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/recycable.svg`,
    recycle_right: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/recycle-right.svg`,
    sad_emoji: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/sad-emoji.svg`,
    time_out: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/time-out.svg`,
    timer: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/timer.svg`,
    arrow_left: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/arrow-left.svg`,
    level_completed: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/level-completed.svg`,
    oops_feedback: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/oops-feedback.svg`,
    good_job_feedback: `${process.env.REACT_APP_URLS_CDN_BASE_URL}/discovery-zone-view/images/icons/recycleRIGHT/good-job-feedback.svg`,
  }
};
